import { useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import { SilverProvider, useSilver } from "@/context/SilverContext";
import Atmosphere from "@/components/silver/layout/Atmosphere";
import WorkspaceHeader from "@/components/silver/layout/WorkspaceHeader";
import SearchFab from "@/components/silver/layout/SearchFab";
import AudienceTool from "@/components/silver/tool/AudienceTool";
import { FilterDrawer } from "@/components/silver/tool/FilterDrawer";
import { HowCalculatedDialog } from "@/components/silver/common/HowCalculatedDialog";
import { SuccessExperience } from "@/components/silver/builder/SuccessExperience";
import { CONTACT } from "@/data/content";

function Workspace() {
  const { submission } = useSilver();
  useEffect(() => {
    const prev = document.title;
    document.title = "Audience workspace | NicheCom";
    return () => { document.title = prev; };
  }, []);
  return (
    <>
      <Atmosphere />
      <WorkspaceHeader />
      <main data-testid="audience-workspace">
        <AudienceTool />
      </main>
      <footer className="border-t border-white/[0.07] bg-[#0C2010]/60" data-testid="workspace-footer">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 text-[12px] text-white/40 sm:flex-row sm:items-center sm:justify-between sm:px-8">
          <p>© NicheCom 2026. Audience intelligence and direct mail from NicheCom Print.</p>
          <p>Questions? <a href={CONTACT.phoneHref} className="text-white/70 hover:text-white">{CONTACT.phone}</a></p>
        </div>
      </footer>
      <FilterDrawer />
      <SearchFab mode="workspace" />
      <HowCalculatedDialog />
      <AnimatePresence>{submission && <SuccessExperience key="success" />}</AnimatePresence>
    </>
  );
}

export default function AudienceWorkspace() {
  return (
    <SilverProvider>
      <Workspace />
    </SilverProvider>
  );
}
